(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1057],{

/***/ 43422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/ebay-promotions-manager/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-03-29",
      tag: "eBay",
      title: "The eBay Promotions Manager: Your Guide to Selling Online",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: "The eBay Promotions Manager: Your Guide to Selling Online"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Learn how to maximize the benefits of eBay Promotions Manager and succeed in setting up your eBay campaigns.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In the digital age, where almost anything can be sold online, it is no surprise that eBay has taken over as one of the most popular platforms for sellers. But how do you get your products on there? What are the benefits of selling through this site? How do eBay Promotions Manager work, and what does it offer its users? In this article, we will answer all these questions and more! We will talk about everything from using promotions effectively to getting ahead in your business."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is eBay Promotions Manager?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay is home to over 1.4 billion listings. Two hundred fifty million of those are promoted listings. If you don't promote your listings well enough, you're most likely losing sales. If you're looking for more ways to increase sales, boost your visibility, and market your products like a Pro. Then, eBay Promotions Manager is for you.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The eBay Promotions Manager is a tool that allows sellers to submit an offer for the promotions section of the site. The offers can create awareness about their products, encourage people to buy more items from them, or increase exposure on the site. Plus, this tool is free to use for store Subscribers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Benefits of eBay Promotions Manager to Sellers "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay promotions managers help sellers boost their exposure, increase sales, and connect to more potential customers. This can be done by creating special offers and campaigns in the Marketing tab of the seller's hub.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay's algorithm considers various things. It uses shipping costs, item price, and units sold\u2013 to name a few. Since there is a lot of competition happening on the platforms, having a well-curated listing is not enough to be ahead of your competitors.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You must also consider setting up advertising and promotion campaigns to attract more potential customers and buy more items in your shop. Many shoppers like getting the best deals possible, so having an item on sale or discounts can be a way to capture their attention.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Plus, eBay also boosts the visibility of listings that provide special discounts and offers, making them more visible to more site shoppers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Here are other benefits of using eBay Promotions: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Boost Exposures"
          }), " - When you use the eBay promotions manager, your listing gets boosted in search results and promotion pages. This results in increased inventory views and a higher conversion rate."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Buyers Spend More"
          }), " - Using the promotions manager effectively and at the right time highlights your relevant item for sale and increases customer traffic. Bundling-related items can attract and encourage buyers to add more items to get a special discount shipping or price.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Getting Ahead of Your Competitors"
          }), " - Having a promoted listing through eBay promotions and advertising gives you leverage against your competitors. It makes it easier for potential buyers to see your items when they search using relevant keywords and will likely make a purchase.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Your \"Sale Price\" will be displayed as the \"Buy It Now\" Price. And when done right during relevant times of the year, it can highlight your products and increase customer traffic on your eBay shop.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Setting your eBay promotions manager can be done using three simple steps: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Access the Promotions Manager through the Marketing Tab under Seller Hub "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Customize your eBay promotions based on your eBay goals and customer preferences. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Launch your eBay product campaign. Finalize, and schedule your start and end dates. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["After one campaign ends, don't forget to check your results in the insights or data provided. Check which areas you need to improve and work on your next campaign.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "5 Types of eBay Promotions "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["There are five available eBay promotions you can choose from. Depending on your goals, you can select one or five to meet your goals, boost your exposure, and maximize this tool.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Order Size Discounts"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This type of eBay promotion lets you offer discounts on products when a buyer purchases two or more items from your shop.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Example Offers: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Buy one shirt at a regular price and get the 2nd shirt at 50% off "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Save 10% when you buy two or more on Children's toys"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Save $10 when you purchase $100 on Men's Jeans. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "How to Set Up Order Size Discounts"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Choose a category you want to promote (women, children, toys, etc.) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Set your offer details. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the items you wish to promote and set an item limit for sale"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Check the details of your campaign plan and launch it."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Tips for a Successful Order Discount Offers: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Adjust your threshold above your average order size or average order value when using order discount offers. This encourages customers to buy more items or spend more on the special discount rate.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["More buyers prefer to get a percentage off over a dollar amount discount. Try which offer discount suits your buyers more, and execute more of it on your next campaign.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["If you have similar margins across your multiple products or categories, having an order size discount offers works best.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["When setting up a dollar-off discount, make sure the price will not exceed the cost of your least expensive item included in the promotion. For example, buy one shirt and get 2nd shirt at $5 unless you want to give away things for free.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Markdown Sales Events"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This Type of eBay promotion lets you decide which product or category you want to offer a discount or reduced price. The seller can decide on the maximum discount threshold they want to provide to their buyers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Examples Offers: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Save up to 40% on last season's spring collection. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Save up to 20% on all iPhone cases. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "How to Set Up Markdown Sales "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to Marketing Hub and Find \"Promotions\" on the left navigation."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click \"Sale Event\" and select sale percentage from the drop-down menu."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the products you want to offer. Click \"Create Inclusion Rule\" or \"Create Exclusion Rule.\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter a brief description of the items to which the discount applies"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Finalize and set your start and end dates"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select a campaign image for the sale"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the offer priority (optional) based on your conditions and launch your plan. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Tips for a Successful in Markdown Sales Offers "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Arrange related items in your sale inventory. This way, relevant items will appear when the buyer searches for something in your shop.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You can set up inventory markdown on items or categories using Strike-through pricing treatments. You can restrict inventory by rules that suit your goals and customer preferences."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["The strike-through pricing lets you show buyers your listing at a discounted price and see the amount of money they'll save along with its new \"Buy it Now\" Price.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["You can set up a maximum threshold when setting a sale percentage. Make sure that buyers can get at least a 10% item discount in the event to attract customer traffic.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Shipping Discounts"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This eBay promotion campaign lets customers save more on shipping when they buy items in a bundle or a certain fixed number. When using the free shipping option, you can select any of the following options:", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free shipping with a minimum order value"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free shipping with a minimum quantity order"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Flat rate shipping shouldered by the seller "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Identify your average order value and offer free shipping for orders that reach your threshold to increase sales and transaction rates.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Example Offers: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Free shipping on orders over $79 "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Buy five items and get free shipping. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "How to Set Up Shipping Discounts "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to \"Marketing Hub\" and select \"Promotions\" on the left navigation. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on the \"Shipping discounts\" to set offer conditions. "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Select the shipping offer you want to give (Choose if with minimum order value, with the minimum quantity, or no minimum order value or quantity threshold)", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select your preferred shipping method and fee (free or flat-rate) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Choose the items you want to offer a shipping discount."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter a brief description of the item or brand in which the shipping discount applies "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Set an end date to the shipping promotion you start "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Upload an image for sale (Highlight products or brands included in the free shipping campaign) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the offer priority (optional) and launch your shipping discounts campaign. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Tips for Successful Shipping Discount Offers "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Always set your threshold above your average order size or order value. For example, your average order value is $45, set your point at $55. This way, it encourages customers to spend more to get free shipping or discounted shipping fee.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Buyers like getting the best deal possible. Most eBay buyers respond well to items offering free shipping. Set a free economy or expedited shipping when a buyer meets your threshold to delight them.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Find your average minimum order value or order size, then offer free shipping to buyers who meet the given threshold.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Communicate to your buyers and offer free shipping if their purchased item is near your given threshold. Most would likely add items or upgrade to a higher class of things to meet this threshold and get free shipping.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Coded Coupons"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This Type of eBay promotion lets the seller increase their sales and boost customer retention through the use of coded coupons. The seller can create vouchers to be given to their buyers publicly (eBay.com) or privately (on their marketing channels) to encourage a repeat purchase. The seller shoulders these discount codes, so it's essential to know your product's margin before offering a coded coupon."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Example Offers: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Use \"Welcomeback5\" to get $5 off on your next purchase! "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Get Buy 1 Get 1 on last season's collection Using \"BOGO22.\" "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Use code \"Springsale\" to get 20% off on our spring collection (Min. Spend of $50 max discount at $20. Terms and Conditions Apply)", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "How to Set a Coded Coupon Campaign: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to Marketing Hub and Select \"Promotions\" "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on \"Create Coupon\" "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Generate your desired coupon and set your conditions (i.e., Type of discount, Minimum spend, maximum discount)", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the items you want to include in this campaign. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Set your start and end dates "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Add a campaign image for your sale "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Review your campaign and launch it. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Tips for a Successful Coded Coupon Campaign "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Include a printed coupon code before shipping your buyers' orders to encourage repeat purchases. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Set requirements like minimum spend, maximum discount, or expiry dates to protect your margin and prevent loss of sales."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offer a discount through coded coupons instead of adjusting your item price on the platform. "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Share your coupons on eBay to increase sales on the platform. You can share it on your search results, listing page, or checkout.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Share your coupons using your other channels. Send it through email, on your social media, or to specific buyers or friends to increase customer traffic and transaction rate.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Volume Pricing"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This is the Type of eBay promotion wherein buyers are encouraged to buy more items to save money or get a better deal. For example, the more things they add to their cart, the more money they save."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Example Offers: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Save 10% when you buy two items "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Save 15% when you buy three items "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Save 20% when you buy five items "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "How to Set a Volume Pricing Offer"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to the marketing hub and find \"Promotions.\""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click \"Volume Pricing\" and set the tiers and the discounts you want to offer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Select the item you wish to include in the deal"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Set the end date of the campaign you start"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Check the details and launch the campaign"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Tips for a Successful Volume Pricing Campaign "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Analyze your data wisely. Make sure your discounted price still gives you enough profit. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Know your customers. It's essential to know and analyze your customer's buying behavior. For example, if it's a first-time customer, providing volume pricing offers can make them spend more. Otherwise, if a frequent buyer always buys items in large quantities, it'll be an unnecessary discount."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Set minimum threshold. It's essential to have your margins protected. Make sure to select a strict minimum amount or quantity so your profit wouldn't be compromised.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Listings Qualification Requirements "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay sets minimum requirements for a listing to be a part of one of these promotions or campaigns. Your listing must include the following to have a special offer:", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Auction-type listings are not supported. Your listings must have a \"Buy it Now\" option. If a buyer bids on an item instead of purchasing it via the \"Buy it Now\" button and the seller accepts it, the item will no longer be eligible for the order discount offers."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Listings must have a parent SKU ID to qualify for the discount offer. Child variation IDs will automatically be fetched through their parent SKU ID. Listings without parent SKU or has child SKU ID only will be ineligible.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Listings with a Minimum Advertise Price (MAP) are not supported. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Setting 5 Promotions at Once "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay sellers can set up five different eBay promotions using the seller hub. However, it's essential to plan it wisely and use available data from your eBay store to ensure that you can maximize the benefits of each campaign.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For example, you have already reduced the price of some of your items for order size discounts. Then you set up a shipping discount for orders over $59. Make sure your discounted price plus the free shipping fee can still give you profits."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["When setting up promotions, it's essential to protect your margins and never take a loss on an item. So before setting up five promotions all at once, remember to analyze your data and understand your buyer's buying behavior.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Promotions work best when it is being set up at the right time. For example, many people would buy in large quantities during the holiday season to save time buying gifts or home decors. This is also the perfect time to offer a volume pricing discount or a free shipping discount. Most people would respond to a percentage off rather than a dollar discount, so you can also plan an order size discount campaign during the year-end sales.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["eBay promotions help you attract more customers, boost visibility, drive repeat purchases, and increase sales when done right. But, you must also remember that aside from eBay, you also have competition on the other platforms. So expanding your exposure is vital in making more sales.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Cross-List Like a Pro"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Getting your listings found on eBay is one way to boost your visibility and make more money. But cross-listing it from one marketplace to another makes you a power seller.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Cross-listing is posting one listing from one e-commerce platform to another to have better visibility and attract more potential buyers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Our intelligent system in OneShop lets you cross-list from Poshmark to eBay like a Pro! We auto-delist a single listing once it's been sold to prevent you from dealing with a bad customer buying experience."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Furthermore, our bot acts as your marketing expert 24/7 and does all the tedious listing work on Poshmark, such as liking, sharing, and following in a human-like activity, so your account won't be limited or flagged down. Plus, sales analytics is always free so that you can improve your eBay promotions more."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["And on top of it, OneShop offers a free 7-day trial with no credit card information required! Sign-up", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "here"
        }), " to see how we help you grow your reselling business! Visit", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/",
          children: "https://tools.oneshop.com/"
        }), " to know more."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/ebay-promotions-manager.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "The eBay Promotions Manager: Your Guide to Selling Online"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Learn how to maximize the benefits of eBay Promotions Manager and succeed in setting up your eBay campaigns."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/ebay-promotions-manager"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/ebay-promotions-manager"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "The eBay Promotions Manager: Your Guide to Selling Online"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Learn how to maximize the benefits of eBay Promotions Manager and succeed in setting up your eBay campaigns."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "March 29th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "March 29th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 52438:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ebay-promotions-manager",
      function () {
        return __webpack_require__(43422);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(52438); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);